export default function randomArrayIndex(arrayLength: number) {
  return Math.floor(Math.random() * arrayLength);
}
